var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.955078H513V342.955H0V0.955078Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.955078H68.4V152.564H0V0.955078Z",
    fill: "#002395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4004 0.955078H136.8V152.564H68.4004V0.955078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.105 0.955078V154.064H0V151.064H213.105V0.955078H216.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.634 149.007L300.823 80.1963H438.478L369.634 149.007ZM346.72 171.955L277.875 103.144V240.8L346.72 171.955ZM369.634 194.903L300.823 263.714H438.478L369.634 194.903ZM392.582 171.955L461.426 103.11V240.765L392.582 171.955Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.955078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWf);
export default __webpack_public_path__ + "static/media/WF.bd119a6f828c5dbbe10765486c807beb.svg";
export { ForwardRef as ReactComponent };